/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_LeadInputs */

const ja_playdata_about_lead = /** @type {(inputs: Playdata_About_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）は、eスポーツ関連の大会・イベントの配信データを分析・レポート化し、皆様のマーケティング活動に活用して頂けるウェブサービスです。`)
};

const en_playdata_about_lead = /** @type {(inputs: Playdata_About_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA is a web service that offers analysis and reporting of distribution and viewership data for most domestic Japanese esports-related competitions and events, for use as market research, sponsorship evaluation, performance analysis, and more.`)
};

/**
* | output |
* | --- |
* | "PLAYDATA is a web service that offers analysis and reporting of distribution and viewership data for most domestic Japanese esports-related competitions and ..." |
*
* @param {Playdata_About_LeadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_lead = /** @type {((inputs?: Playdata_About_LeadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_LeadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_lead(inputs)
	return en_playdata_about_lead(inputs)
});